import React from 'react';

import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    formInput: {
        width: "270px",
        border: "1px solid #80868b",
        outline: "none",
        paddingLeft: "16px",
        borderRadius: "26px",
        height: "34px"
    },
    formButton: {
        marginLeft: "11px",
        borderRadius: "26px",
        textTransform: "none"
    },
    "@media (max-width: 767px)": {
        formInput: {
            width: "190px"
        }
    }   
}))

export default function SubscribeForm({ }) {
    const [emailAddress, setEmailAddress] = React.useState("");
    const classes = useStyles();

    const handleSubscription = () => {
        // Google Analytics event
    }

    const handleTextChange = (e) => {
        const text = e.target.value;
        setEmailAddress(text);
    }

    return (
        <form
            id="sub-form"
            method="post"
            action="https://lifeshack.us19.list-manage.com/subscribe/post?u=86fec8b983f1df74a98cb2fba&amp;id=3c566d394b"
            name="mc-embedded-subscribe-form"
            id="mc-embedded-subscribe-form"
            class="validate"
            target="_blank"
            noValidate=""
            onSubmit={handleSubscription}
        >
            <div
            style={{ position: "absolute", left: "-5000px" }}
            ariaHidden="true"
            >
            <input
                type="text"
                name="b_86fec8b983f1df74a98cb2fba_3c566d394b"
                tabIndex="-1"
                value=""
            />
            </div>
            <input
                class="email-input"
                type="email"
                value={emailAddress}
                style={{ visibility: "hidden", width: 0 }}
                name="EMAIL"
                placeholder="Enter your email"
                id="mce-EMAIL"
            ></input>
            <input placeholder="your@email.com" onChange={handleTextChange} className={classes.formInput} />
            <Button variant="contained" color="primary" type="submit" name="subscribe" value="Subscribe" id="mc-embedded-subscribe" className={classes.formButton}>Subscribe</Button>
        </form>        
    )
}